import type { RootState } from 'types'

const citiesList = (state: RootState) => state.nova.cities
const warehousesList = (state: RootState) => state.nova.warehouses

export const NovaSelectors = {
  citiesList,
  warehousesList,
}
